<section class="rx-card" role="document" [attr.aria-labelledby]="screen === 'cover' ? labelId : titleId">

  <div *ngIf="screen === 'cover'" class="rx-screen">
    <rms-release-cover
      [cover]="cover"
      [coverUrl]="coverUrl"
      mode="modal"
      [labelId]="labelId"
      [showSeeWhatsNew]="canSeeWhatsNew"
      [secondaryKey]="secondaryKey"
      (seeWhatsNew)="seeWhatsNew()"
      (secondary)="close()">
    </rms-release-cover>
    <div *ngIf="loadingPages" class="rx-card__loading" role="status">
      <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
      <span class="visually-hidden">{{ "RELEASE_NOTES.CARD.LOADING" | translate }}</span>
    </div>
  </div>

  <div *ngIf="screen === 'slides' && currentPage as page" class="rx-screen rx-slide">
    <header class="rx-slide__head">
      <div>
        <div class="rx-slide__eyebrow">{{ cover?.releaseDateLabel }}</div>
        <h2 class="rx-slide__title" [attr.id]="titleId">{{ "RELEASE_NOTES.CARD.TITLE" | translate }}</h2>
      </div>
      <button type="button" class="btn btn-close rx-slide__close" (click)="close()"
              [attr.aria-label]="'RELEASE_NOTES.CARD.CLOSE_WHATS_NEW' | translate"></button>
    </header>

    <div class="rx-slide__body" [ngClass]="bodyClass(page)">
      <div class="rx-slide__copy" aria-live="polite" aria-atomic="true">
        <h3 class="rx-slide__heading"><rms-release-note-rich-text [text]="page.heading"></rms-release-note-rich-text></h3>
        <p *ngIf="page.benefit" class="rx-slide__benefit"><rms-release-note-rich-text [text]="page.benefit"></rms-release-note-rich-text></p>
        <ul *ngIf="page.bullets?.length" class="rx-slide__bullets">
          <li *ngFor="let bullet of page.bullets; trackBy: trackByIndex"><rms-release-note-rich-text [text]="bullet"></rms-release-note-rich-text></li>
        </ul>
      </div>

      <div *ngIf="hasMediaPane(page)" class="rx-slide__media" [class.rx-slide__media--real]="!!currentMedia"
           (click)="openLightbox()" (keydown.enter)="onMediaKeydown($event)" (keydown.space)="onMediaKeydown($event)">
        <ng-container *ngIf="currentMedia as media; else placeholder">
          <ng-container *ngIf="!failed[media.s3Reference] && mediaUrls[media.s3Reference] !== null; else placeholder">
            <ng-container *ngIf="isVideo(media); else still">
              <video *ngIf="mediaUrls[media.s3Reference]" [src]="mediaUrls[media.s3Reference]" muted [muted]="true" playsinline preload="metadata"
                     [attr.autoplay]="autoplays(page) ? '' : null" [attr.loop]="autoplays(page) ? '' : null"
                     [style.aspect-ratio]="aspectRatio(media)" [style.max-height.px]="fullMaxHeight"
                     [attr.aria-label]="page.mediaAlt" (error)="failed[media.s3Reference] = true"></video>
              <span *ngIf="!autoplays(page)" class="rx-slide__play" aria-hidden="true"><i class="fa fa-play"></i></span>
            </ng-container>
            <ng-template #still>
              <img *ngIf="mediaUrls[media.s3Reference]" [src]="mediaUrls[media.s3Reference]" [attr.alt]="page.mediaAlt || ''"
                   [style.aspect-ratio]="aspectRatio(media)" (error)="failed[media.s3Reference] = true">
            </ng-template>
          </ng-container>
          <button type="button" class="rx-slide__expand" (click)="$event.stopPropagation(); openLightbox()"
                  [attr.aria-label]="'RELEASE_NOTES.CARD.EXPAND' | translate">
            <i class="fa fa-expand" aria-hidden="true"></i>
          </button>
          <div *ngIf="page.media.length > 1" class="rx-slide__mdots" (click)="$event.stopPropagation()"
               (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
            <button *ngFor="let item of page.media; let i = index; trackBy: trackByIndex" type="button"
                    [class.on]="i === mediaIndex" (click)="showMedia(i)"
                    [attr.aria-label]="'RELEASE_NOTES.CARD.IMAGE_N_OF' | translate: { n: i + 1, total: page.media.length }"
                    [attr.aria-pressed]="i === mediaIndex"></button>
          </div>
        </ng-container>
        <ng-template #placeholder>
          <div class="rx-slide__placeholder">
            <i class="fa fa-picture-o" aria-hidden="true"></i>
            <span>{{ page.mediaAlt }}</span>
          </div>
        </ng-template>
      </div>
    </div>

    <footer class="rx-slide__foot">
      <nav class="rx-pager" [attr.aria-label]="'RELEASE_NOTES.CARD.PAGER' | translate">
        <button type="button" class="rx-pager__arrow" (click)="prev()" [attr.aria-label]="'RELEASE_NOTES.CARD.BACK' | translate">
          <span aria-hidden="true">‹</span>
        </button>
        <ng-container *ngIf="pages.length > 1">
          <button *ngFor="let p of pages; let i = index; trackBy: trackByIndex" type="button" class="rx-pager__num"
                  [class.active]="i === index" (click)="goTo(i)"
                  [attr.aria-current]="i === index ? 'page' : null"
                  [attr.aria-label]="'RELEASE_NOTES.CARD.PAGE_N_OF' | translate: { n: i + 1, total: pages.length }">{{ i + 1 }}</button>
        </ng-container>
        <button type="button" class="rx-pager__arrow" (click)="next()" [disabled]="isLastSlide"
                [attr.aria-label]="'RELEASE_NOTES.CARD.NEXT' | translate">
          <span aria-hidden="true">›</span>
        </button>
      </nav>
      <span class="rx-slide__ver">{{ "RELEASE_NOTES.CARD.FOOT_VERSION" | translate: { version: cover?.version } }}</span>
    </footer>
  </div>

  <rms-release-media-lightbox *ngIf="lightbox" [url]="lightbox.url" [isVideo]="lightbox.isVideo" [alt]="lightbox.alt"
                              (closed)="closeLightbox()"></rms-release-media-lightbox>
</section>

<div *ngIf="context === 'preview' && lensOptions.length" class="rx-lens">
  <label class="rx-lens__label" for="rx-lens-select">{{ "RELEASE_NOTES.PREVIEW.AS" | translate }}</label>
  <select id="rx-lens-select" class="form-select form-select-sm rx-lens__select" [ngModel]="lensIndex" (ngModelChange)="setLens($event)">
    <option *ngFor="let lens of lensOptions; let i = index" [ngValue]="i">{{ lens.label }}</option>
  </select>
  <span *ngIf="lensNote as note" class="rx-lens__note">{{ note.key | translate: note.params }}</span>
</div>
